// import React from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Navigation } from "swiper/modules";

// import "swiper/css";
// import "swiper/css/navigation";

// const testimonials = [
//   {
//     // img: "images/testimonial/pic1.jpg",
//     name: "Mr. Rahul Sharma",
//     text: "Excellent cab service by Shivai Travels. The driver was professional, the car was clean, and the journey was very comfortable.",
//   },

//   {
//     // img: "images/testimonial/pic2.jpg",
//     name: "Miss. Priya Patil",
//     text: "Booked an Innova for our family trip and had an amazing experience. Affordable pricing and on-time pickup service.",
//   },

//   {
//     // img: "images/testimonial/pic3.jpg",
//     name: "Mr. Amit Deshmukh",
//     text: "Shivai Travels provided the best outstation taxi service from Pune. Smooth ride, polite driver, and hassle-free booking.",
//   },

//   {
//     // img: "images/testimonial/pic4.jpg",
//     name: "Miss. Sneha Kulkarni",
//     text: "Very reliable travel company. The Tempo Traveller was spacious and perfect for our group tour. Highly recommended.",
//   },

//   {
//     // img: "images/testimonial/pic5.jpg",
//     name: "Mr. Karan Jadhav",
//     text: "I regularly use Shivai Travels for airport transfers and business trips. Always punctual with excellent customer support.",
//   },
// ];

// const TestimonialSection = () => {
//   return (
//     <div className="section-full p-t150 site-bg-white twm-testimonial-section-wrap wow fadeInDown">
//       <div className="container">

//         {/* TITLE */}
//         <div className="row">
//           <div className="col-lg-6 col-md-12">
//             <div className="section-head left">
//               <div className="twm-sm-title left">Testimonial</div>
//               <h2 className="twm-large-title site-text-dark">
//                 What Our Customers Say
//               </h2>
//             </div>
//           </div>
//         </div>

//         {/* SLIDER */}
//         <div className="section-content">
//           <Swiper
//             modules={[Autoplay, Navigation]}
//             spaceBetween={30}
//             slidesPerView={3}
//             loop={true}
//             autoplay={{
//               delay: 2500,
//               disableOnInteraction: false,
//             }}
//             navigation={true}
//             breakpoints={{
//               0: { slidesPerView: 1 },
//               768: { slidesPerView: 2 },
//               1200: { slidesPerView: 3 },
//             }}
//           >
//             {testimonials.map((item, index) => (
//               <SwiperSlide key={index}>
//                 <div className="twm-testimonial2">

//                   {/* HEADER */}
//                   <div className="twm-testimonial-head">
//                     <div className="media-pic">
//                       <img src={item.img} alt={item.name} />
//                     </div>
//                     <div className="twm-author-detail">
//                       <h3 className="twm-title">{item.name}</h3>
//                       <div className="twm-position">Customer</div>
//                     </div>
//                   </div>

//                   {/* CONTENT */}
//                   <div className="twm-testimonial-detail">
//                     <p>{item.text}</p>

//                     <div className="twm-rating-wrap">
//                       {[...Array(5)].map((_, i) => (
//                         <span key={i}>
//                           <i className="fa fa-star"></i>
//                         </span>
//                       ))}
//                     </div>
//                   </div>

//                   {/* QUOTE ICON */}
//                   <div className="twm-quote-icon">
//                     <img src="images/quote.png" alt="quote" />
//                   </div>

//                 </div>
//               </SwiperSlide>
//             ))}
//           </Swiper>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default TestimonialSection;












import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

const testimonials = [
  {
    name: "Mr. Rahul Sharma",
    text: "Excellent cab service by Shivai Travels. The driver was professional, the car was clean, and the journey was very comfortable.",
  },
  {
    name: "Miss. Priya Patil",
    text: "Booked an Innova for our family trip and had an amazing experience. Affordable pricing and on-time pickup service.",
  },
  {
    name: "Mr. Amit Deshmukh",
    text: "Shivai Travels provided the best outstation taxi service from Pune. Smooth ride, polite driver, and hassle-free booking.",
  },
  {
    name: "Miss. Sneha Kulkarni",
    text: "Very reliable travel company. The Tempo Traveller was spacious and perfect for our group tour. Highly recommended.",
  },
  {
    name: "Mr. Karan Jadhav",
    text: "I regularly use Shivai Travels for airport transfers and business trips. Always punctual with excellent customer support.",
  },
];

const TestimonialSection = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <div className="section-full p-t150 site-bg-white twm-testimonial-section-wrap wow fadeInDown">
      <div className="container">
        {/* TITLE */}
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <div className="section-head left">
              <div className="twm-sm-title left">Testimonial</div>
              <h2 className="twm-large-title site-text-dark">
                What Our Customers Say
              </h2>
            </div>
          </div>
        </div>

        {/* SLIDER */}
        <div className="section-content position-relative">
          {/* Custom Navigation Buttons */}
          <button ref={prevRef} className="custom-swiper-btn custom-prev">
            ❮
          </button>

          <button ref={nextRef} className="custom-swiper-btn custom-next">
            ❯
          </button>

          <Swiper
            modules={[Autoplay, Navigation]}
            spaceBetween={30}
            slidesPerView={3}
            loop={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
            }}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            breakpoints={{
              0: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1200: { slidesPerView: 3 },
            }}
          >
            {testimonials.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="twm-testimonial2">
                  {/* HEADER */}
                  <div className="twm-testimonial-head">
                    <div className="twm-author-detail">
                      <h3 className="twm-title">{item.name}</h3>
                      <div className="twm-position">Customer</div>
                    </div>
                  </div>

                  {/* CONTENT */}
                  <div className="twm-testimonial-detail">
                    <p>{item.text}</p>

                    <div className="twm-rating-wrap">
                      {[...Array(5)].map((_, i) => (
                        <span key={i}>
                          <i className="fa fa-star"></i>
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* QUOTE ICON */}
                  <div className="twm-quote-icon">
                    <img src="images/quote.png" alt="quote" />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      {/* Custom Arrow Styles */}
      <style jsx>{`
        .custom-swiper-btn {
          position: absolute;
          top: -70px;
          width: 45px;
          height: 45px;
          border: none;
          border-radius: 50%;
          background: #ff6600;
          color: #fff;
          font-size: 20px;
          cursor: pointer;
          z-index: 10;
          transition: all 0.3s ease;
        }

        .custom-swiper-btn:hover {
          background: #222;
        }

        .custom-prev {
          right: 60px;
        }

        .custom-next {
          right: 0;
        }

        .twm-rating-wrap .fa-star {
          color: #ffc107;
          margin-right: 3px;
        }
      `}</style>
    </div>
  );
};

export default TestimonialSection;

